// The Add person fields Registration and Add activation both use.
//
// The write is createIdentity with role client_viewer. That names an approver
// and does not grant Console access. Clients.tsx owns the company-page form;
// these are the same boxes so a person added from a show is the same person.

import type { ReactNode } from "react";
import { FieldRow } from "@nova/desk-ui/kit";

export type PersonDraft = {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  jobTitle: string;
};

export const emptyPersonDraft = (): PersonDraft => ({
  firstName: "",
  lastName: "",
  email: "",
  phone: "",
  jobTitle: "",
});

export function identityWriteFromDraft(draft: PersonDraft, clientId: string): {
  email: string;
  role: "client_viewer";
  clientId: string;
  firstName: string | null;
  lastName: string | null;
  phone: string | null;
  jobTitle: string | null;
} {
  const trimOrNull = (value: string): string | null => {
    const trimmed = value.trim();
    return trimmed === "" ? null : trimmed;
  };
  return {
    email: draft.email.trim(),
    role: "client_viewer",
    clientId,
    firstName: trimOrNull(draft.firstName),
    lastName: trimOrNull(draft.lastName),
    phone: trimOrNull(draft.phone),
    jobTitle: trimOrNull(draft.jobTitle),
  };
}

export function AddPersonFields({
  draft,
  onDraft,
  busy,
  emailLocked = false,
}: {
  readonly draft: PersonDraft;
  readonly onDraft: (draft: PersonDraft) => void;
  readonly busy: boolean;
  readonly emailLocked?: boolean;
}): ReactNode {
  return (
    <>
      <FieldRow label="Their first name">
        <input
          className="input"
          name="new-identity-first-name"
          value={draft.firstName}
          onChange={(event) => onDraft({ ...draft, firstName: event.target.value })}
          disabled={busy}
        />
      </FieldRow>
      <FieldRow label="Their last name">
        <input
          className="input"
          name="new-identity-last-name"
          value={draft.lastName}
          onChange={(event) => onDraft({ ...draft, lastName: event.target.value })}
          disabled={busy}
        />
      </FieldRow>
      <FieldRow label="Their email address">
        <input
          className="input"
          type="email"
          name="new-identity-email"
          value={draft.email}
          onChange={(event) => onDraft({ ...draft, email: event.target.value })}
          disabled={busy || emailLocked}
        />
      </FieldRow>
      <FieldRow label="Telephone (optional)">
        <input
          className="input"
          type="tel"
          name="new-identity-phone"
          value={draft.phone}
          onChange={(event) => onDraft({ ...draft, phone: event.target.value })}
          disabled={busy}
        />
      </FieldRow>
      <FieldRow label="Title (optional)">
        <input
          className="input"
          name="new-identity-title"
          value={draft.jobTitle}
          onChange={(event) => onDraft({ ...draft, jobTitle: event.target.value })}
          disabled={busy}
        />
      </FieldRow>
    </>
  );
}
